import { useRef, useState } from "react";
import { Upload, FileCheck, Loader2 } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

/* Column cell: Upload Signed PDF OR open existing signed PDF link. */
export default function SignedPdfCell({ report, endpoint, onUploaded }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  if (report.signed_pdf_url) {
    return (
      <a
        href={`${process.env.REACT_APP_BACKEND_URL}${report.signed_pdf_url}`}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 px-2 py-1 text-xs font-bold uppercase tracking-wider bg-emerald-100 text-emerald-800 hover:bg-emerald-200"
        data-testid={`signed-pdf-link-${report.id}`}
      >
        <FileCheck className="w-3.5 h-3.5" /> Signed
      </a>
    );
  }

  const handleFile = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!f.name.toLowerCase().endsWith(".pdf")) {
      toast.error("Please upload a PDF file");
      return;
    }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      await api.post(`${endpoint}/${report.id}/signed`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Signed PDF uploaded");
      onUploaded?.();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        onClick={() => ref.current?.click()}
        disabled={busy}
        data-testid={`upload-signed-${report.id}`}
        className="inline-flex items-center gap-1 px-2 py-1 text-xs font-bold uppercase tracking-wider bg-amber-50 text-amber-800 hover:bg-amber-100 border border-amber-300 disabled:opacity-50"
      >
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}
        Upload Signed
      </button>
      <input ref={ref} type="file" accept="application/pdf" className="hidden" onChange={handleFile} />
    </>
  );
}
